import * as React from "react";
const SvgMoon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.081 2.509a1 1 0 0 1-.067 1.085 6 6 0 0 0 8.392 8.392l.064-.04a1 1 0 0 1 1.526.853v.083A10 10 0 1 1 11.118 2.004a1 1 0 0 1 .963.505m7.48 12.175A7.999 7.999 0 0 1 9.316 4.439a8 8 0 1 0 10.245 10.245", clipRule: "evenodd" }));
export default SvgMoon;
